export const normalizeDatePickerValue = (date?: string): string | undefined => {
    if (date === undefined) {
        return undefined;
    }

    return new Date(date).toISOString();
};
